// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"Modal_wrapper__1JXnf","backdrop":"Modal_backdrop__whqNK","modal":"Modal_modal__PGvj5"};